// removed by extract-text-webpack-plugin
module.exports = {"videoList_wrapper":"videosList__videoList_wrapper__2ka93","videoListItem_wrapper":"videosList__videoListItem_wrapper___I5p2","left":"videosList__left__1Fzjt","right":"videosList__right__1Gskr","relatedWrapper":"videosList__relatedWrapper__1r2rz"};


//////////////////
// WEBPACK FOOTER
// ./src/components/widgets/VideosList/videosList.css
// module id = 50
// module chunks = 0